/**
 * modes/lab-mode.js
 * Quản lý phòng thí nghiệm tương tác (Voxel Science Lab) và bàn thí nghiệm hoá học.
 */

import * as THREE from 'three';
import { BlockyAvatar } from '../../avatars/blocky-avatar.js';

export function setupLabMode(state, helpers = {}) {
  const { clearAvatars, clearCityScene, clearLabBench } = helpers;
  if (typeof clearAvatars === 'function') clearAvatars(state);
  if (typeof clearCityScene === 'function') clearCityScene(state);
  if (typeof clearLabBench === 'function') clearLabBench(state);

  if (state.studioEnvironmentGroup) state.studioEnvironmentGroup.visible = true;
  if (state.pedestalGroup) state.pedestalGroup.visible = false;
  if (state.gridHelper) state.gridHelper.visible = false;

  if (state.camera && state.controls) {
    state.camera.position.set(0, 2.2, 5.0);
    state.controls.target.set(0, 1.0, 0);
  }

  const teacher = new BlockyAvatar('TEACHER');
  teacher.root.position.set(-1.1, 0, 0.2);
  teacher.root.rotation.y = 0.5;
  teacher.playAction('explain');
  state.scene.add(teacher.root);
  state.activeAvatars.push(teacher);
  state.mainAvatar = teacher;

  const student = new BlockyAvatar('HOC_SINH_KHAN_QUANG');
  student.root.position.set(1.1, 0, 0.2);
  student.root.rotation.y = -0.5;
  student.playAction('cheer');
  state.scene.add(student.root);
  state.activeAvatars.push(student);

  buildLabBench(state);
  teacher.speak('Chào em! Hôm nay chúng ta cùng kiểm tra hiện tượng chìm nổi nhé.');
}

export function buildLabBench(state) {
  if (state.labBenchGroup) state.scene.remove(state.labBenchGroup);
  const labBenchGroup = new THREE.Group();

  const benchMat = new THREE.MeshStandardMaterial({ color: 0x334155, roughness: 0.5 });
  const topMat = new THREE.MeshStandardMaterial({ color: 0xe2e8f0, roughness: 0.3 });

  const topGeo = new THREE.BoxGeometry(1.6, 0.08, 0.9);
  const top = new THREE.Mesh(topGeo, topMat);
  top.position.set(0, 0.84, 0);
  top.castShadow = true;
  labBenchGroup.add(top);

  const legGeo = new THREE.BoxGeometry(0.08, 0.84, 0.08);
  [
    [-0.7, -0.35],
    [0.7, -0.35],
    [-0.7, 0.35],
    [0.7, 0.35]
  ].forEach(([lx, lz]) => {
    const leg = new THREE.Mesh(legGeo, benchMat);
    leg.position.set(lx, 0.42, lz);
    leg.castShadow = true;
    labBenchGroup.add(leg);
  });

  const beakerMat = new THREE.MeshPhysicalMaterial({ color: 0x38bdf8, transparent: true, opacity: 0.65 });
  const beakerGeo = new THREE.CylinderGeometry(0.12, 0.12, 0.32, 16);
  const beaker = new THREE.Mesh(beakerGeo, beakerMat);
  beaker.position.set(-0.25, 1.04, 0);
  labBenchGroup.add(beaker);

  state.scene.add(labBenchGroup);
  state.labBenchGroup = labBenchGroup;
}

export function clearLabBench(state) {
  if (state.labBenchGroup) {
    if (state.labBenchGroup.parent) {
      state.labBenchGroup.parent.remove(state.labBenchGroup);
    } else {
      state.scene.remove(state.labBenchGroup);
    }
    state.labBenchGroup = null;
  }
}
